export const left = [
  {
    text: "Find friends",
    img: "friends",
  },
  {
    text: "Memories",
    img: "memories",
  },
  {
    text: "Groups",
    img: "groups",
    notification: "5 new",
  },
  {
    text: "Marketplace",
    img: "marketplace",
  },
  {
    text: "Watch",
    img: "watch",
    notification: "9 new videos",
  },
  {
    text: "Saved",
    img: "saved",
  },
  {
    text: "Pages",
    img: "pages",
  },
  {
    text: "Events",
    img: "events",
  },
  {
    text: "Ad Center",
    img: "ad",
  },
  {
    text: "Ads Manager",
    img: "ads",
  },
  {
    text: "Campus",
    img: "campus",
  },
  {
    text: "Climate science center",
    img: "climate",
  },
  {
    text: "Community Help",
    img: "community",
  },
  {
    text: "COVID-19 Information Center",
    img: "covid",
  },
  {
    text: "Emotional health",
    img: "emotional",
  },
  {
    text: "Facebook Pay",
    img: "pay",
  },
  {
    text: "Favorites",
    img: "fav",
  },
  {
    text: "Fundraisers",
    img: "fund",
  },
  {
    text: "Gaming Video",
    img: "gaming",
  },
  {
    text: "Jobs",
    img: "jobs",
  },
  {
    text: "Live videos",
    img: "live",
  },
  {
    text: "Messenger",
    img: "messenger",
  },
  {
    text: "Messenger Kids",
    img: "messkids",
  },
  {
    text: "Most recent",
    img: "recent",
  },
  {
    text: "Play Games",
    img: "play",
  },
  {
    text: "Recent ad activity",
    img: "recentad",
  },
  {
    text: "Weather",
    img: "weather",
  },
];

export const stories = [
  {
    profile_picture: "../../stories/profile1.jpg",
    profile_name: "Elon Musk",
    image: "../../stories/1.jpg",
  },
  {
    profile_picture: "../../stories/profile2.jpg",
    profile_name: "South park",
    image: "../../stories/2.png",
  },
  {
    profile_picture: "../../stories/profile3.png",
    profile_name: "The Sopranos",
    image: "../../stories/3.jpg",
  },
  {
    profile_picture: "../../stories/profile4.jfif",
    profile_name: "Football World",
    image: "../../stories/4.jpg",
  },
  {
    profile_picture: "../../stories/profile5.png",
    profile_name: "The Witcher Wild Hunt",
    image: "../../stories/5.jfif",
  },
];
